import { ThemeOverride } from "@chakra-ui/react";

const colors: ThemeOverride["colors"] = {
  gray: {
    "50": "#f5f5f5",
    "100": "#ebebebe0",
    "400": "#909090",
  },
  persimmon: {
    "50": "#f8fbf8",
    "100": "#eef6ee",
    "200": "#e0ebe0",
    "300": "#cae0ca",
    "400": "#b2cab2",
    "500": "#8ba58f",
    "600": "#778a77",
    "700": "#657865",
    "800": "#536453",
    "900": "#415141",
  },
  brown: {
    "50": "#f8fbf8",
    "100": "#eef6ee",
    "200": "#e0ebe0",
    "300": "#cae0ca",
    "400": "#b2cab2",
    "500": "#8ba58f",
    "600": "#778a77",
    "700": "#657865",
    "800": "#536453",
    "900": "#415141",
  },
  golden: {
    "50": "#f3f7f3",
    "100": "#e7efe7",
    "200": "#cfdecf",
    "300": "#b7cdb7",
    "400": "#86ab86",
    "500": "#55895a",
    "600": "#4d7b51",
    "700": "#406744",
    "800": "#335237",
    "900": "#29432d",
  },
  brand: {
    "50": "#f2f3f7",
    "100": "#e4e6ee",
    "200": "#c9cedd",
    "300": "#adb5cc",
    "400": "#919bba",
    "500": "#313b59",
    "600": "#2c3550",
    "700": "#252d43",
    "800": "#1e2436",
    "900": "#171c2a",
  },
  dark: {
    "50": "#fdfdfd",
    "100": "#fcfcfc",
    "200": "#f7f7f7",
    "300": "#f2f2f2",
    "400": "#e8e8e8",
    "500": "#dedede",
    "600": "#c8c8c8",
    "700": "#a7a7a7",
    "800": "#858585",
    "900": "#6d6d6d",
  },
};

export default colors;
